import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import {loader, toastr} from '../CommonActions';

export const SELECT_PAYMENT = 'SELECT_PAYMENT';
export const SAVE_BILLINGINFO = 'SAVE_BILLINGINFO';

//const ROOT_API_URL = 'https://localhost:44350/api';
//`https://tscramembershipportalapi-dev.azurewebsites.net/api`;

const successColor =  "success";
const errorColor = "danger";
const warningColor = "warning";

export function selectPayment(selectedPaymentObject) {
    return function (dispatch) {
        dispatch({
            type: SELECT_PAYMENT,
            selectedPayment: selectedPaymentObject
        })
    }
}
export function saveBillingInfo(model) {
    return function (dispatch) {
        dispatch(loader(true));
        axios.post(`${ROOT_API_URL}/Signup/SaveUserBillingInfo`, model)
            .then((response) => {
                if (response && response.data && response.data.issuccess) {
					dispatch({
						type: SAVE_BILLINGINFO,
						payload: response.data.source
                    });
				}
				else {
                    var err = response && response.data ? response.data.message : "Error Saving Billing Information"; 
                    dispatch(toastr(true,err, warningColor));
                }
                dispatch(loader(false));
            })
            .catch((response) => {
                var err = response && response.data ? response.data.message : 'Network Connection Error';
                dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
            });
        };
}

